module.exports = require('./Avatar');
